import { IMenuStyleData } from "@pageBuilder/typings";
import { BaseItemsStylesRenderer } from "./base-items-styles-renderer";
import { CssProperties } from "../../../../models/css-property";

export class OverlinedItemsStyleRenderer extends BaseItemsStylesRenderer {

    protected override getActiveNavSpanProperties(style: IMenuStyleData): CssProperties {
        const cssProperties = super.getActiveNavSpanProperties(style);
        if (style?.linkColorStyleData?.colorClicked) {
            cssProperties.add("border-color", style?.linkColorStyleData?.colorClicked);
        }

        return cssProperties;
    }

    protected override getNavSpanHoveredProperties(style: IMenuStyleData): CssProperties {
        const cssProperties = super.getNavSpanHoveredProperties(style);
        if (style?.linkColorStyleData?.colorHovered) {
            cssProperties.add("border-color", style?.linkColorStyleData?.colorHovered);
        }

        return cssProperties;
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    public getStyleSpecificSelectors(id: string): Array<string> {
        return [];
    }

}